import { Action } from 'redux';

import { ToggleBackgroundJobExtendedInfoDialog } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { IBackgroundJobInfo } from '../types/BackgroundJobs';

export interface ToggleBackgroundJobExtendedInfoDialogAction extends Action {
    backgroundJob: IBackgroundJobInfo;
}

export function toggleBackgroundJobExtendedInfoDialog(
    backgroundJob: IBackgroundJobInfo
): ToggleBackgroundJobExtendedInfoDialogAction {
    return {
        type: ToggleBackgroundJobExtendedInfoDialog,
        backgroundJob,
    };
}

export const isToggleBackgroundJobExtendedInfoDialog = isActionFactory<ToggleBackgroundJobExtendedInfoDialogAction>(ToggleBackgroundJobExtendedInfoDialog);
